var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckAll = function SvgCheckAll(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#656D77",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M1.75 2h12.5M1.75 6h12.5M1.75 10h6.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#656D77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.172 13 2.121 2.121 5.657-5.657"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckAll);
export default ForwardRef;